module.exports = {
  pathPrefix: '/', // Prefix for all links. If you deploy your site to example.com/portfolio your pathPrefix should be "portfolio"

  siteTitle: 'Lars Tijhuis', // Navigation and Site Title
  siteTitleAlt: 'Lars Tijhuis\' Blog', // Alternative Site title for SEO
  siteUrl: 'https://lars.tijhuis.blog', // Domain of your site. No trailing slash!
  siteLanguage: 'en', // Language Tag on <html> element
  siteLogo: '/logos/logo-1024.png', // Used for SEO and manifest
  siteBanner: '/social/banner.jpg',
  siteDescription: 'Sharing my experience on Code quality and testing, building awesome software, and the occasional travelling',

  // siteFBAppID: '123456789', // Facebook App ID
  userTwitter: 'larstijhuis', // Twitter Username
  ogSiteName: 'Lars Tijhuis - Blog', // Facebook Site Name

  // Manifest and Progress color
  themeColor: '#000053',
  backgroundColor: '#000053',

  // Settings for typography.js
  headerFontFamily: 'Bitter',
  bodyFontFamily: 'Open Sans',
  baseFontSize: '18px',
};



// WEBPACK FOOTER //
// ./config/SiteConfig.js